import { AppConfigModel } from "@/models/app-config/app-config.interface";

export class AppConfigService {
  private static INSTANCE = new AppConfigService();

  private APP_CONFIG = "APP_CONFIG";

  static get instance() {
    return this.INSTANCE;
  }

  public getApiUrl() {
    const appConfig: AppConfigModel = this.getAppConfig();
    return appConfig ? appConfig.api_endpoint_url : process.env.VUE_APP_API_URL;
  }

  public getStrapiApiUrl() {
    const appConfig: AppConfigModel = this.getAppConfig();
    return appConfig
      ? appConfig.strapi_api_url
      : process.env.VUE_APP_STRAPI_API_URL;
  }

  public getStrapiWithGraphqlApiUrl() {
    const appConfig: AppConfigModel = this.getAppConfig();
    return appConfig
      ? appConfig.strapi_graphql_api_url
      : process.env.VUE_APP_GRAPHQL_URL;
  }

  public getS3FilesPathUrl() {
    const appConfig: AppConfigModel = this.getAppConfig();
    return appConfig
      ? appConfig.s3_files_path
      : process.env.VUE_APP_S3_FILES_PATH;
  }

  public getS3CertificatesFilesPathUrl() {
    const appConfig: AppConfigModel = this.getAppConfig();
    return appConfig
      ? appConfig.s3_certificates_files_path
      : process.env.VUE_APP_S3_CERTIFICATES_FILES_PATH;
  }

  public getS3FormPathUrl() {
    const appConfig: AppConfigModel = this.getAppConfig();
    return appConfig
      ? appConfig.s3_form_path
      : process.env.VUE_APP_S3_FORM_PATH;
  }

  public getCADREUrl() {
    const appConfig: AppConfigModel = this.getAppConfig();
    return appConfig
      ? appConfig.cadre_url
      : process.env.VUE_APP_STRAPI_CADRE_API_URL;
  }

  public getEnvironmentType() {
    const appConfig: AppConfigModel = this.getAppConfig();
    return appConfig ? appConfig.environment : process.env.VUE_APP_ENVIRONMENT;
  }

  public getClientId() {
    const appConfig: AppConfigModel = this.getAppConfig();
    return appConfig ? appConfig.client_id : process.env.VUE_APP_CLIENT_ID;
  }

  public getClientKey() {
    const appConfig: AppConfigModel = this.getAppConfig();
    return appConfig ? appConfig.client_key : process.env.VUE_APP_CLIENT_KEY;
  }

  public getEnvDetails() {
    return process.env.VUE_APP_CLIENT_KEY;
  }

  private getAppConfig() {
    let appConfigAsJson = null;
    const appConfigAsString: string | null = localStorage.getItem(
      this.APP_CONFIG
    );
    if (appConfigAsString) {
      appConfigAsJson = JSON.parse(appConfigAsString);
    }
    return appConfigAsJson;
  }

  public getCyapssUrl() {
    const appConfig: AppConfigModel = this.getAppConfig();
    return appConfig ? appConfig.cyapss_url : process.env.VUE_APP_CYAPSS_URL;
  }

  public getCprsUrl() {
    const appConfig: AppConfigModel = this.getAppConfig();
    return appConfig ? appConfig.cprs_url : process.env.VUE_APP_CPRS_URL;
  }

  public getShowDelete() {
    const appConfig: AppConfigModel = this.getAppConfig();
    return appConfig ? !!appConfig?.show_delete : false;
  }
}
export const appConfigService = AppConfigService.instance;
